module.exports = __webpack_public_path__ + "static/media/transfer-DRAFT.ac1231f8.svg";